__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-04-07-1775558973-stable-dev/";